import SearchWrapper from './SearchWrapper.vue'

const searchComponents = [
  SearchWrapper,
]

export default searchComponents
